import { TAccount } from "@/api/v1_0";
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement, useMemo } from "react";
import { ExpenseCategory } from "./_dependencies";
import { IExpenseCategoriesProps } from "./types";

export const ExpenseCategories: FunctionComponent<IExpenseCategoriesProps> =
  observer(
    (props: IExpenseCategoriesProps): ReactElement<IExpenseCategoriesProps> => {
      const { addAccount, closeAccount, openAccount, ...restProps } = props;
      const store = useStore();
      const expenseCategories: Array<TAccount> = useMemo(
        () =>
          [...store.wallet.expenseCategories.values()].map(
            (expenseCategory) => ({
              ...expenseCategory,
              balance:
                store.operations.accounts.get(expenseCategory.uuid)?.amount ||
                0,
            })
          ),
        [store.wallet.accounts, store.operations.accounts]
      );

      return (
        <div className="contentBox marginBottom whiteBlockBg">
          <div className="contentBoxHeader">
            <h3>Расходы</h3>
            {false && (
              <a href="#" className="link" onClick={addAccount}>
                Добавить
              </a>
            )}
          </div>
          <div className="row">
            {expenseCategories.map((expenseCategory) => (
              <ExpenseCategory
                key={expenseCategory.uuid}
                expenseCategory={expenseCategory}
                onPress={openAccount}
              />
            ))}
          </div>
        </div>
      );
    }
  );
